import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-r-t-order',
  templateUrl: './r-t-order.component.html',
  styleUrls: ['./r-t-order.component.scss']
})
export class RTOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
